module.exports = __webpack_public_path__ + "static/media/aguarde.5c9c40ad.gif";